import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import './Login.css';

export default function Login() {
  const { login, loading, error, setError } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    await login(email, password);
  };

  return (
    <div className="login-page">
      <button className="login-theme-btn" onClick={toggleTheme} title="Toggle theme">
        {theme === 'light' ? '🌙' : '☀️'}
      </button>

      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo-mark">E</div>
          <div>
            <h1 className="login-title">Ellertek Mail</h1>
            <p className="login-subtitle">ellertek.co.tz</p>
          </div>
        </div>

        <p className="login-welcome">Sign in to your work email</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email address</label>
            <input
              type="email"
              className="form-input"
              placeholder="you@ellertek.co.tz"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <div className="input-wrapper">
              <input
                type={showPass ? 'text' : 'password'}
                className="form-input"
                placeholder="Enter your password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="show-pass-btn"
                onClick={() => setShowPass(s => !s)}
                tabIndex={-1}
              >
                {showPass ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          {error && (
            <div className="login-error" role="alert">
              <span>⚠</span> {error}
            </div>
          )}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? (
              <span className="login-spinner"></span>
            ) : (
              'Sign in'
            )}
          </button>
        </form>

        <div className="login-footer">
          <p>Trouble signing in? Contact your IT administrator.</p>
          <p className="login-server-hint">
            Connected to: <code>ellertek.co.tz</code> (IMAP :993 SSL)
          </p>
        </div>
      </div>

      <div className="login-bg-decoration" aria-hidden="true">
        <div className="login-bg-circle c1"></div>
        <div className="login-bg-circle c2"></div>
      </div>
    </div>
  );
}
